export const PRODUCTS = [
  {
    id: "tv-spec-01",
    lookupKey: "tv_spec_01",
    number: "01",
    name: "Vanguard-X Tactical Chrono Watch",
    category: "TACTICAL WEARABLES",
    price: 189,
    tier: "FIELD PRO",
    rating: "MIL-STD-810H / 200M",
    imageUrl: "https://images.unsplash.com/photo-1771646752362-adbae785e731?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MDV8MHwxfHNlYXJjaHw0fHx0YWN0aWNhbCUyMG1pbGl0YXJ5JTIwd2F0Y2glMjBydWdnZWR8ZW58MHx8fHwxNzg4MzI3MjQzfDA&ixlib=rb-4.1.0&q=85",
    description: "Shock-absorbing resin casing with solar telemetry, barometric altimeter, and stealth display mode.",
    specs: { Casing: "Carbon-fiber core guard", Battery: "10-year solar quartz", Signal: "Tritium + LED backlight" },
  },
  {
    id: "tv-spec-02",
    lookupKey: "tv_spec_02",
    number: "02",
    name: "Apex Titan Chronograph MK-IV",
    category: "TACTICAL WEARABLES",
    price: 420,
    tier: "TIER-1 SPECOPS",
    rating: "SAPPHIRE / 300M",
    imageUrl: "https://images.unsplash.com/photo-1613520701290-480b81948f43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDE3fDB8MHwxfHNlYXJjaHwzfHx0YWN0aWNhbCUyMG1pbGl0YXJ5JTIwd2F0Y2glMjBydWdnZWR8ZW58MHx8fHwxNzg4MzI3MjQzfDA&ixlib=rb-4.1.0&q=85",
    description: "Blackout tactical chronometer with anti-reflective sapphire, zero magnetic interference, and mission timer.",
    specs: { Casing: "Grade 5 ballistic titanium", Movement: "Swiss heavy caliber auto", Bezel: "Ceramic tactical compass" },
  },
  {
    id: "tv-spec-03",
    lookupKey: "tv_spec_03",
    number: "03",
    name: "TacCom-800 Active Noise Cancelling Field Headset",
    category: "FIELD COMMS",
    price: 149,
    tier: "FIELD PRO",
    rating: "IPX7 / 32DB NRR",
    imageUrl: "https://images.unsplash.com/photo-1669480380822-5e72ece8ffcc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHx0YWN0aWNhbCUyMG1pbGl0YXJ5JTIwd2F0Y2glMjBydWdnZWR8ZW58MHx8fHwxNzg4MzI3MjQzfDA&ixlib=rb-4.1.0&q=85",
    description: "Suppresses impact noise while amplifying squad whispers through a reinforced, low-latency comms array.",
    specs: { Runtime: "68 hours continuous", Audio: "Dual high-gain ambient mic", Link: "Bluetooth 5.4 + NATO 2-pin" },
  },
  {
    id: "tv-spec-04",
    lookupKey: "tv_spec_04",
    number: "04",
    name: "HydroShield Extreme Weather Audio Monitors",
    category: "FIELD COMMS",
    price: 79,
    tier: "EVERYDAY RUGGED",
    rating: "IP68 / 10M DROP",
    imageUrl: "https://images.unsplash.com/photo-1616750819287-955503f65d42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHx0YWN0aWNhbCUyMG1pbGl0YXJ5JTIwd2F0Y2glMjBydWdnZWR8ZW58MHx8fHwxNzg4MzI3MjQzfDA&ixlib=rb-4.1.0&q=85",
    description: "Stormproof audio monitors engineered for sweat, dust, and hard movement in rough training conditions.",
    specs: { Membrane: "Hydrophobic nanocoating", Driver: "40mm beryllium", Protection: "10-meter drop proof" },
  },
  {
    id: "tv-spec-05",
    lookupKey: "tv_spec_05",
    number: "05",
    name: "Aegis Modular Radio & Studio Monitor",
    category: "FIELD COMMS",
    price: 229,
    tier: "FIELD PRO",
    rating: "MIL-SPEC SHOCK",
    imageUrl: "https://images.unsplash.com/photo-1722891067479-5fd39edbfc3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx0YWN0aWNhbCUyMG1pbGl0YXJ5JTIwd2F0Y2glMjBydWdnZWR8ZW58MHx8fHwxNzg4MzI3MjQzfDA&ixlib=rb-4.1.0&q=85",
    description: "Modular field comms with interchangeable ear cups, boom mic pass-through, and zero-latency audio.",
    specs: { Chassis: "Anodized aluminum frame", Frequency: "10Hz–42kHz", Cables: "Braided steel-sheathed" },
  },
  {
    id: "tv-spec-06",
    lookupKey: "tv_spec_06",
    number: "06",
    name: "Nomad Hardened Expedition Field Pack",
    category: "POWER & GEAR",
    price: 119,
    tier: "EVERYDAY RUGGED",
    rating: "1000D CORDURA",
    imageUrl: "https://images.pexels.com/photos/16253057/pexels-photo-16253057.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Heavyweight pack with an armored laptop vault, solar bank pass-through, and modular utility webbing.",
    specs: { Volume: "35L modular capacity", Shell: "Ballistic nylon", Hardware: "YKK AquaGuard zippers" },
  },
  {
    id: "tv-spec-07",
    lookupKey: "tv_spec_07",
    number: "07",
    name: "IronClad 48,000mAh Ballistic Power Station",
    category: "POWER & SOLAR",
    price: 139,
    tier: "FIELD PRO",
    rating: "IP67 / 140W PD",
    imageUrl: "https://images.pexels.com/photos/29566303/pexels-photo-29566303.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Dense expedition power hub for laptops, comms, and an emergency 500-lumen tactical SOS beacon.",
    specs: { Cells: "LiFePO4 / 3000+ cycles", Outputs: "2× 100W USB-C PD", Beacon: "500-lumen SOS" },
  },
  {
    id: "tv-spec-08",
    lookupKey: "tv_spec_08",
    number: "08",
    name: "Ghost-Cipher 4TB Encrypted Rugged SSD",
    category: "HARDENED STORAGE",
    price: 299,
    tier: "TIER-1 SPECOPS",
    rating: "FIPS 140-2 / AES-256",
    imageUrl: "https://images.unsplash.com/photo-1613520701290-480b81948f43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDE3fDB8MHwxfHNlYXJjaHwzfHx0YWN0aWNhbCUyMG1pbGl0YXJ5JTIwd2F0Y2glMjBydWdnZWR8ZW58MHx8fHwxNzg4MzI3MjQzfDA&ixlib=rb-4.1.0&q=85",
    description: "Ballistic-grade portable storage with hardware zeroize trigger and tamper detection on every transfer.",
    specs: { Speed: "2,800 MB/s over USB4", Shell: "CNC milled magnesium", Security: "Biometric PIN + zeroize" },
  },
  {
    id: "tv-spec-09",
    lookupKey: "tv_spec_09",
    number: "09",
    name: "Relay-9 Hardened Field Radio",
    category: "FIELD COMMS",
    price: 279,
    tier: "FIELD PRO",
    rating: "IP67 / 24-HOUR LINK",
    imageUrl: "https://static.prod-images.emergentagent.com/jobs/76c8ebec-ad45-4934-92fc-ff12faf0955d/images/7207e2e8da7c31f1e47416690fd145baf9cf623973642d49c80b178265b67447.jpeg",
    description: "A sealed handheld relay with a long-range antenna, tactile controls, and a signal path built for rough weather.",
    specs: { Shell: "Shock-sealed polymer", Runtime: "24-hour field cycle", Link: "Encrypted long-range relay" },
  },
  {
    id: "tv-spec-10",
    lookupKey: "tv_spec_10",
    number: "10",
    name: "Atlas Fold 120W Solar Panel",
    category: "POWER & SOLAR",
    price: 189,
    tier: "FIELD PRO",
    rating: "120W / IP65",
    imageUrl: "https://static.prod-images.emergentagent.com/jobs/76c8ebec-ad45-4934-92fc-ff12faf0955d/images/434826285563b52b73b7ea34ccae77696fdf9584f18385b70362b1e9584341f2.jpeg",
    description: "A fold-flat charging surface for the edge of camp, with a hard case and a clean pass-through to expedition power.",
    specs: { Output: "120W peak", Case: "Rugged olive canvas", Protection: "IP65 weather sealed" },
  },
  {
    id: "tv-spec-11",
    lookupKey: "tv_spec_11",
    number: "11",
    name: "Blacksite Vault 2TB Rugged SSD",
    category: "HARDENED STORAGE",
    price: 179,
    tier: "FIELD PRO",
    rating: "AES-256 / USB4",
    imageUrl: "https://static.prod-images.emergentagent.com/jobs/76c8ebec-ad45-4934-92fc-ff12faf0955d/images/d6205d78091a40ed4c8910528b47d79fd4acf20c5b1e663182fdccf724aa5edb.jpeg",
    description: "A compact, armored archive for the files that cannot be left behind, wrapped in a cable-ready field shell.",
    specs: { Capacity: "2TB solid state", Speed: "2,800 MB/s over USB4", Security: "Hardware AES-256" },
  },
  {
    id: "tv-spec-12",
    lookupKey: "tv_spec_12",
    number: "12",
    name: "Ranger-55 GPS Field Watch",
    category: "TACTICAL WEARABLES",
    price: 249,
    tier: "FIELD PRO",
    rating: "100M / GPS / SOLAR",
    imageUrl: "https://static.prod-images.emergentagent.com/jobs/76c8ebec-ad45-4934-92fc-ff12faf0955d/images/4acbff8fa56856f2c50461a51c57ce4ec679b86caf93a290039e2560cc04c035.jpeg",
    description: "A low-glow navigation watch with solar endurance, a legible field face, and a strap made for long movement.",
    specs: { Navigation: "GPS + route back", Battery: "21-day solar reserve", Water: "100-meter resistant" },
  },
  {
    id: "tv-spec-13",
    lookupKey: "tv_spec_13",
    number: "13",
    name: "Nightline Compact Thermal Monocular",
    category: "FIELD OPTICS",
    price: 899,
    tier: "TIER-1 SPECOPS",
    rating: "256 SENSOR / IP67",
    imageUrl: "https://static.prod-images.emergentagent.com/jobs/76c8ebec-ad45-4934-92fc-ff12faf0955d/images/378f98adb604464581e2699301f359fc892db4a47584cc24c07cccdc7d4ae45a.jpeg",
    description: "A compact thermal optic for night navigation and perimeter awareness, protected by a sealed grip-ready body.",
    specs: { Sensor: "256 × 192 thermal core", Runtime: "6-hour field cycle", Shell: "IP67 armored body" },
  },
  {
    id: "tv-spec-14",
    lookupKey: "tv_spec_14",
    number: "14",
    name: "Signal Support Heavyweight Tee",
    category: "TACTICAL MERCH",
    price: 32,
    tier: "CAUSE EDITION",
    rating: "100% COTTON / UNISEX",
    imageUrl: "https://static.prod-images.emergentagent.com/jobs/76c8ebec-ad45-4934-92fc-ff12faf0955d/images/4396b313a431b556a700f5023ae4c78028310fe5ec8e853de829746612c01771.jpeg",
    description: "A heavyweight charcoal tee for the people behind the signal. The same 0.10% pledge is reserved on every dispatch.",
    specs: { Fabric: "Heavyweight cotton", Fit: "Relaxed unisex cut", Finish: "Low-key amber stitch" },
  },
  {
    id: "tv-spec-15",
    lookupKey: "tv_spec_15",
    number: "15",
    name: "Field Issue Utility Overshirt",
    category: "TACTICAL MERCH",
    price: 68,
    tier: "CAUSE EDITION",
    rating: "RIPSTOP / 4 POCKET",
    imageUrl: "https://static.prod-images.emergentagent.com/jobs/76c8ebec-ad45-4934-92fc-ff12faf0955d/images/ada98242e4da244f5f4832f7f411c85f2fcde70ac86c3849ca4e793314a32ead.jpeg",
    description: "A workwear layer with reinforced pockets and quiet olive utility. Wear the cause without turning it into a costume.",
    specs: { Shell: "Cotton ripstop", Storage: "Four utility pockets", Detail: "Reinforced amber stitch" },
  },
  {
    id: "tv-spec-16",
    lookupKey: "tv_spec_16",
    number: "16",
    name: "Service Mark Challenge Coin + Patch",
    category: "CAUSE KEEPSAKES",
    price: 24,
    tier: "CAUSE EDITION",
    rating: "BRUSHED METAL / EMBROIDERED",
    imageUrl: "https://static.prod-images.emergentagent.com/jobs/76c8ebec-ad45-4934-92fc-ff12faf0955d/images/971c8dd309a7cd0b6728f1c7fdfc986d0ee0e90919a4ba2aeac3255ad1f45b92.jpeg",
    description: "A pocket-sized compass mark and embroidered patch for the people who keep the signal moving forward.",
    specs: { Coin: "Brushed black metal", Patch: "Embroidered compass mark", Pack: "Keepsake presentation sleeve" },
  },
];

export const CATEGORIES = ["ALL GEAR", "FIELD COMMS", "TACTICAL WEARABLES", "FIELD OPTICS", "POWER & SOLAR", "POWER & GEAR", "HARDENED STORAGE", "TACTICAL MERCH", "CAUSE KEEPSAKES"];
export const TROOP_PLEDGE_RATE = 0.001;
export const FREE_SHIRT_THRESHOLD = 200;
export const FREE_SHIRT_PROMO_START_ISO = "2026-09-15T00:00:00Z";
export const MILLION_SALES_MILESTONE = 1000000;
export const MILLION_TROOP_DONATION = 10000;
export const formatCurrency = (value) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value);
export const troopContribution = (value) => value * TROOP_PLEDGE_RATE;
